import * as React from 'react';
import {renderElement} from '../../utils';
import {useDevAlert} from '@packages/systems/spring-hooks';

// @ts-expect-error - TS7031 - Binding element 'children' implicitly has an 'any' type. | TS7031 - Binding element 'prefix' implicitly has an 'any' type. | TS7031 - Binding element 'suffix' implicitly has an 'any' type.
export const LinkContent = ({children, prefix, suffix}) => {
  // In practice, we can expect that one of children, prefix, or suffix will be defined because without any of them,
  // nothing would actually render. However, because none of those props are actually required we have to
  // explicitly handle none of them being defined or Flow complains. So we'll return null if we somehow end up
  // in this unlikely scenario and devAlert the reason why nothing is showing up.
  useDevAlert(
    !children && !prefix && !suffix,
    'Link requires a value for children, prefix, or suffix. Currently, none are defined.'
  );

  if (prefix || suffix) {
    return (
      <>
        {prefix ? renderElement(prefix, {'data-slot': 'prefix'}) : null}
        {children}
        {suffix ? renderElement(suffix, {'data-slot': 'suffix'}) : null}
      </>
    );
  }

  if (children) return children;

  return null;
};
